<template>
  <form>
    <div id="hiddenReviewsPanel">
      <div id="hiddenReviews">
        <div v-for="(feefoReview, idx) in feefoReviews" :key="idx" class="review-item">
          <div class="review-item__head clearfix">
            <span v-html="convertRating(feefoReview.productOrServiceRating)" class="review-item__stars" />
            <span class="review-item__title">
              <div v-if="feefoReview.reviewTitle != null">"{{ feefoReview.reviewTitle }}"</div>
            </span>
          </div>
          <div class="review-item__author">
            <strong>
              By
              <span v-if="feefoReview.reviewerName == null"> MedExpress Customer </span>
              <span v-if="feefoReview.reviewerName != null">
                {{ feefoReview.reviewerName }}
              </span>
              <span v-if="feefoReview.reviewerLocation != null"> ({{ feefoReview.reviewerLocation }}) </span>
            </strong>
            on {{ convertDateTime(feefoReview.isoReviewDate) }}
          </div>
          <div class="row review-item__body">
            <div class="col-sm-5">
              <p class="blue">Product:</p>
              {{ feefoReview.productReview }}
            </div>
            <div class="col-sm-5">
              <p class="blue">Service:</p>
              <p>{{ feefoReview.serviceReview }}</p>
            </div>
          </div>
          <div class="review-link">(<a target="_blank" :href="feefoReview.feefoUrl">read full review on Feefo</a>)</div>
        </div>
      </div>
    </div>
    <br />
    <div style="text-align: center">
      <button
        v-if="hasMore"
        v-on:click="loadMoreReviews"
        class="btn btn-primary btn-lg"
        value="Show more reviews"
        id="loadMoreBtn"
        v-text="'Show more reviews'"
      />
    </div>
  </form>
</template>

<script>
import Vue from "vue";
import $ from "jquery";

export default Vue.extend({
  props: ["reviews", "url", "count"],
  data: function () {
    return {
      feefoReviews: this.reviews,
    };
  },
  computed: {
    nextIndex: function () {
      return this.feefoReviews.length;
    },
    hasMore: function () {
      return this.feefoReviews.length < this.count;
    },
  },
  methods: {
    convertRating(rating) {
      var fullStar = '<span class="common-sprite sprite-star"></span>';
      var halfStar = '<span class="common-sprite sprite-star-half"></span>';
      var emptyStar = '<span class="common-sprite sprite-star-empty"></span>';

      rating = this.roundToUpperHalf(rating);

      var fullStarCount = parseInt(rating);
      var halfStarCount = parseInt((rating - fullStarCount) * 2);
      var emptyStarCount = 5 - fullStarCount - halfStarCount;

      var result = [];

      for (let i = 0; i < fullStarCount; i++) {
        result.push(fullStar);
      }
      for (let i = 0; i < halfStarCount; i++) {
        result.push(halfStar);
      }
      for (let i = 0; i < emptyStarCount; i++) {
        result.push(emptyStar);
      }
      return result.join("");
    },
    convertDateTime(reviewDate) {
      var monthNames = [
        "Placeholder",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      var day = reviewDate.split("-")[2];
      var monthIndex = parseInt(reviewDate.split("-")[1]);
      var year = reviewDate.split("-")[0];

      return day + " " + monthNames[monthIndex] + " " + year;
    },
    roundToUpperHalf(rating) {
      rating = rating * 2;
      rating = Math.ceil(rating);
      rating = rating / 2;
      return rating;
    },
    loadMoreReviews(e) {
      e.preventDefault();
      $.post(this.url + "&index=" + this.nextIndex)
        .then((response) => {
          response.forEach((review) => {
            this.feefoReviews.push(review);
          });
        })
        .fail((error) => {
          console.log("Post request failure when trying to get more reviews");
        });
    },
  },
});
</script>
